import React from "react";
import { Link } from "react-router-dom";
import { FiArrowRight, FiMail, FiMapPin, FiPhoneCall } from "react-icons/fi";

import { companyInfo, navigationLinks } from "../../data/siteContent";

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="section-shell site-footer__grid">
        <div className="site-footer__brand">
          <img src={companyInfo.logo} alt={companyInfo.name} className="site-footer__logo" />
          <h2>{companyInfo.name}</h2>
          <p>{companyInfo.description}</p>

          <Link to="/contact" className="button button-secondary site-footer__button">
            Speak with our team
            <FiArrowRight aria-hidden="true" />
          </Link>
        </div>

        <div className="site-footer__column">
          <h3>Quick links</h3>
          <ul>
            {navigationLinks.map((link) => (
              <li key={link.label}>
                <Link to={link.to}>{link.label}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="site-footer__column">
          <h3>Contact</h3>
          <ul className="site-footer__contact">
            <li>
              <FiPhoneCall aria-hidden="true" />
              <div className="site-footer__phone-stack">
                <a href={companyInfo.phoneHref}>{companyInfo.primaryPhone}</a>
                <a href={companyInfo.secondaryPhoneHref}>{companyInfo.secondaryPhone}</a>
              </div>
            </li>
            <li>
              <FiMail aria-hidden="true" />
              <a href={`mailto:${companyInfo.email}`}>{companyInfo.email}</a>
            </li>
            <li>
              <FiMapPin aria-hidden="true" />
              <span>{companyInfo.location}</span>
            </li>
          </ul>
        </div>

        <div className="site-footer__column">
          <h3>Export focus</h3>
          <p>
            Premium eco tableware, professional documentation support, and clear buyer
            coordination from inquiry through dispatch.
          </p>
          <div className="site-footer__social">
            {companyInfo.socialLinks.map((social) => (
              <a key={social.label} href={social.href} target="_blank" rel="noreferrer">
                {social.label}
              </a>
            ))}
          </div>
        </div>
      </div>

      <div className="section-shell site-footer__bottom">
        <p>{`Copyright ${currentYear} ${companyInfo.name}. All rights reserved.`}</p>
        <p>Built for international buyers seeking reliable Indian sourcing.</p>
      </div>
    </footer>
  );
}

export default Footer;
